import { formatCurrency } from './currency.js';
import { toPlainDecimalString, truncateDecimalSignificantsDown } from './numbers.js';
import { isNumberUnit } from '@exodus/currency';
export const DUST_THRESHOLD = 1e-6;
export function isDustAmount(amount) {
    return amount > 0 && amount < DUST_THRESHOLD;
}
function isNumberUnitType(obj) {
    return isNumberUnit(obj);
}
const parseAmount = (amount) => {
    if (isNumberUnitType(amount)) {
        return amount.toDefaultNumber();
    }
    if (typeof amount !== 'string') {
        amount = amount.toString();
    }
    amount = amount.replace(/[,_]/gu, '');
    return parseFloat(amount);
};
export const canShowPlusSign = (amount) => {
    amount = parseAmount(amount);
    if (isNaN(amount))
        return false;
    return amount > 0 && !isDustAmount(amount);
};
export function formatAssetAmount(amount, { useGrouping = true, maxSignificant = 6, withPlusSign = false } = {}) {
    amount = parseAmount(amount);
    const convertDust = useGrouping;
    if (isNaN(amount))
        return '0';
    if (amount === 0)
        return '0';
    if (convertDust && isDustAmount(amount))
        return '0';
    const absAmount = amount >= 0 ? truncateDecimalSignificantsDown(amount, maxSignificant) : Math.abs(amount);
    const absStr = toPlainDecimalString(absAmount);
    const integerPart = absStr.split('.')[0];
    const intLength = integerPart.length;
    const roundedToDecimal = formatCurrency(absAmount, {
        useGrouping: false,
        minimumFractionDigits: 0,
        maximumFractionDigits: maxSignificant,
    });
    const withMaxSignificant = formatCurrency(roundedToDecimal, {
        useGrouping,
        maximumSignificantDigits: Math.max(maxSignificant, intLength),
    });
    if (convertDust && parseFloat(withMaxSignificant) === 0 && amount !== 0) {
        return '0';
    }
    if (amount < 0)
        return `-${withMaxSignificant}`;
    if (withPlusSign && amount > 0)
        return `+${withMaxSignificant}`;
    return withMaxSignificant;
}
export const formatBalance = (balance, asset) => `${formatAssetAmount(balance)} ${asset.displayTicker}`;
